export default {
  personGroup: {}
}
